window.chartBav = {
	data: {
		// Liqui
		bruttowerte: [],
		deckungsstoecke: [],
		vorsorgebeitraege: [],
		leistungen: [],
		// Steuer
		zves: [],
		sozialversicherungen: [],
		// Zusatzversicherungen
		bu_leistungen: [],
		beitragsbefreiung_beitraege: [],
		burente_beitraege: [],
		todesfallschutz_versicherungssummen: [],
		todesfallschutz_beitraege: [],
		risiko_versicherungssummen: [],
		risiko_beitraege: [],
		// Sonstiges
		leistungsdatum: 0,
		bewertungsdatum: 0,
		startdatum: 0,
		enddatum: 0,
	},

	showLoading() {
		if (this.chart) this.chart.showLoading()
	},

	hideLoading() {
		if (this.chart) this.chart.hideLoading()
	},

	init() {
		this.chart = new Highcharts.stockChart("chart_bav", {
			chart: {
				events: {
					selection: function (event) {
						return zoomIn(chartBav, event)
					},
				},
			},
			xAxis: {
				ordinal: false,
				min: this.data.startdatum,
				max: this.data.enddatum,
				plotLines: [
					{
						id: "bewertungsplotline",
						color: "#2F3435",
						width: 2,
						dashStyle: "longdashdot",
						zIndex: 10,
						bewertungsdatum: this.data.bewertungsdatum,
						value: this.data.bewertungsdatum - 60 * 60 * 24 * (365 - 30.41) * 1000, // Das Chart öffnet immer in der Jahresansicht
						label: {
							text: `Aktuelle Vertragsmitteilung<br>zum ${moment(new Date(this.data.bewertungsdatum)).format("MM/YYYY")}`,
							rotation: 0,
							y: 15,
							x: 10,
							textAlign: "left",
							style: {
								color: chartFontColorGrau,
								fontSize: "14px",
							},
						},
					},
				],
				events: {
					afterSetExtremes: function (event) {
						const chart = event.target.chart,
							min = event.min,
							max = event.max

						updateDataGrouping(chart, min, max)
						updateBewertungPlotline(chart)
					},
				},
			},
			yAxis: [
				{},
				{
					opposite: true,
				},
			],
			legend: {
				enabled: true,
			},

			plotOptions: {
				area: {
					stacking: "normal",
				},
			},

			series: this.seriesLiqui(),
		})

		// Wenn der Chart Zeitraum kleiner ist als die Monatsgrenze das DataGrouping deaktivieren
		updateDataGrouping(this.chart, this.data.startdatum, this.data.enddatum)
	},

	update() {
		if (!this.chart) return

		this.chart.showLoading()

		const seriesArrays = [this.seriesLiqui(), this.seriesSteuer(), this.seriesBuschutz(), this.seriesTodesfallschutz()]
		const alleSeries = [].concat(...seriesArrays)

		alleSeries.forEach((serie) => {
			const s = this.chart.get(serie.id)
			if (s) s.setData(serie.data, false)
		})

		// Leistungsdatum anpassen
		const serieVertragswert = this.chart.get("vertragswert")
		if (serieVertragswert) serieVertragswert.zones[0].value = this.data.leistungsdatum

		// xAchse: Min und Max aktualisieren
		this.updateXAxisMinMax()

		// Bewertungsline aktualisieren
		this.updateBewertungLinie()

		this.chart.redraw({ duration: chartAnimationDuration })
		this.chart.hideLoading()
	},

	updateXAxisMinMax() {
		const seriesMaxValues = this.chart.series.map((serie) => (Array.isArray(serie.xData) ? serie.xData.slice(-1)[0] : undefined)),
			xAxisMaxValue = Math.max(this.data.enddatum, ...seriesMaxValues.filter((element) => element !== undefined))
		this.chart.xAxis[0].update({ min: this.data.startdatum, max: xAxisMaxValue })
	},

	updateBewertungLinie() {
		const plotLineOptions = this.chart.xAxis[0].options.plotLines[0]
		plotLineOptions.bewertungsdatum = this.data.bewertungsdatum
		plotLineOptions.value = this.data.bewertungsdatum
		plotLineOptions.label.text = `Aktuelle Vertragsmitteilung<br>zum ${moment(new Date(this.data.bewertungsdatum)).format("MM / YYYY")}`

		if (this.chart.options.plotOptions.series.dataGrouping.enabled) {
			plotLineOptions.value = plotLineOptions.bewertungsdatum - 60 * 60 * 24 * (365 - 30.41) * 1000
		}

		this.chart.xAxis[0].options.plotLines[0] = Object.assign({}, this.chart.xAxis[0].options.plotLines[0], plotLineOptions)
	},

	updateSeriesData(seriesData) {
		// Alle Series entfernen
		while (this.chart.series.length > 0) {
			this.chart.series[0].remove(false)
		}

		// Steuer-Series hinzufügen
		seriesData.forEach((serie) => {
			this.chart.addSeries(serie, false)
		})

		// XAchse Max Data prüfen und ggf. aktualisieren
		this.updateXAxisMinMax()
		this.chart.redraw({ duration: chartAnimationDuration })
	},

	seriesLiqui() {
		return [
			{
				name: "Vertragswert",
				id: "bruttowert",
				legendName: "Vertragswert",
				yAxis: 0,
				type: "area",
				zIndex: 0,
				stack: "vertragswert",
				data: this.data.bruttowerte,
			},
			{
				name: "Deckungsstock",
				id: "deckungsstock",
				yAxis: 0,
				type: "area",
				color: farbeDeckungsstock,
				zIndex: 0,
				visible: true,
				showInLegend: false,
				stack: "vertragswert",
				linkedTo: "bruttowert",
				data: this.data.deckungsstoecke,
			},
			{
				name: "Vorsorgebeitrag",
				id: "beitrag",
				legendName: "Beitrag",
				yAxis: 1,
				type: "column",
				color: farbeBeitrag1,
				zIndex: 1,
				data: this.data.vorsorgebeitraege,
			},
			{
				name: "Leistung",
				id: "leistung",
				legendName: "Leistung",
				yAxis: 1,
				type: "column",
				color: farbeLeistung,
				zIndex: 1,
				data: this.data.leistungen,
			},
		]
	},

	seriesSteuer() {
		return [
			{
				name: "steuerpflichtiges Einkommen",
				id: "zve",
				legendName: "steuerpflichtiges Einkommen",
				type: "column",
				color: farbeZuVersteuerndesEinkommen,
				data: this.data.zves,
			},
			{
				name: "sozialpflichtiges Einkommen",
				id: "sve",
				legendName: "sozialpflichtiges Einkommen",
				type: "column",
				color: farbeSozialpflichtigesEinkommen,
				stack: "sve",
				data: this.data.sozialversicherungen,
			},
		]
	},

	seriesBuschutz() {
		return [
			{
				name: "Gesamte Versicherungsleistung",
				id: "bu_leistung",
				legendName: "Versicherungsleistung",
				yAxis: 0,
				type: "area",
				color: farbeLeistung,
				opacity: "0.5",
				zIndex: 0,
				data: this.data.bu_leistungen,
			},
			{
				name: "Beitrag zur BU-Rente",
				id: "burente",
				legendName: "Beitrag zur BU-Rente",
				yAxis: 0,
				type: "column",
				color: farbeBeitrag1,
				zIndex: 0,
				data: this.data.burente_beitraege,
			},
			{
				name: "Beitrag zur Beitragsbefreiung",
				id: "beitragsbefreiung",
				legendName: "Beitrag zur Beitragsbefreiung",
				yAxis: 0,
				type: "column",
				color: farbeBeitrag2,
				zIndex: 0,
				data: this.data.beitragsbefreiung_beitraege,
			},
		]
	},

	seriesTodesfallschutz() {
		return [
			{
				name: "Todesfallschutz",
				id: "versicherungssumme_todesfallschutz",
				legendName: "Versicherungsleistung",
				yAxis: 0,
				type: "area",
				color: farbeLeistung,
				opacity: "0.5",
				zIndex: 0,
				data: this.data.todesfallschutz_versicherungssummen,
			},
			{
				name: "Risikolebensversicherung",
				id: "versicherungssumme_risiko",
				legendName: "Gesamte Versicherungsleistung",
				yAxis: 0,
				type: "area",
				color: farbeLeistung,
				opacity: "0.5",
				zIndex: 0,
				linkedTo: "versicherungssumme_todesfallschutz",
				data: this.data.risiko_versicherungssummen,
			},
			{
				name: "Beitrag zur Risikolebensversicherung",
				id: "beitrag_risiko",
				legendName: "Beiträge",
				yAxis: 1,
				type: "column",
				color: farbeBeitrag1,
				zIndex: 1,
				data: this.data.risiko_beitraege,
			},
			{
				name: "Beitrag zum Todesfallschutz",
				id: "beitrag_todesfallschutz",
				legendName: "Beitrag zum Todesfallschutz",
				yAxis: 1,
				type: "column",
				color: farbeBeitrag1,
				linkedTo: "beitrag_risiko",
				zIndex: 1,
				data: this.data.todesfallschutz_beitraege,
			},
		]
	},
}
